import { render, staticRenderFns } from "./HeartSoundEffect.vue?vue&type=template&id=325ba033&scoped=true&"
import script from "./HeartSoundEffect.vue?vue&type=script&lang=js&"
export * from "./HeartSoundEffect.vue?vue&type=script&lang=js&"
import style0 from "./HeartSoundEffect.vue?vue&type=style&index=0&id=325ba033&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325ba033",
  null
  
)

export default component.exports